var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4995 3.36914C7.28089 3.36939 3.86963 6.78131 3.86963 11C3.86988 15.2185 7.28104 18.6296 11.4995 18.6299C15.7182 18.6299 19.1301 15.2186 19.1304 11C19.1304 6.78116 15.7184 3.36914 11.4995 3.36914ZM11.4995 4.5498C15.0687 4.5498 17.9497 7.43084 17.9497 11C17.9495 14.5689 15.0685 17.4492 11.4995 17.4492C7.93073 17.449 5.05054 14.5688 5.05029 11C5.05029 7.431 7.93057 4.55006 11.4995 4.5498Z",
    fill: "#42526D",
    stroke: "#42526D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2622 6.62598L10.646 7.24219L10.5405 7.34863L10.646 7.4541L14.1929 11L10.646 14.5459L10.5405 14.6523L10.646 14.7588L11.2622 15.374L11.3687 15.4805L11.4741 15.374L15.7427 11.1064L15.8481 11L11.3687 6.52051L11.2622 6.62598Z",
    fill: "#42526D",
    stroke: "#42526D",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39014 10.4092V11.5898H15.1704V10.4092H7.39014Z",
    fill: "#42526D",
    stroke: "#42526D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionArrow);
export default __webpack_public_path__ + "static/media/ActionArrow.b341413c69a60d793cb48b4074de0c57.svg";
export { ForwardRef as ReactComponent };